import { useTranslation } from 'react-i18next';

import { PanelNotice, PanelWaiting } from '@/components/hub/PanelNotice';
import { useBackgammonTournaments } from '@/hooks/useBackgammonTournaments';
import { limuloFailure } from '@/lib/limulo/errors';
import { LimuloDegraded } from '@/routes/limulo/LimuloDegraded';
import { TorneiQuattroTab } from '@/routes/limulo/TorneiQuattroTab';

/**
 * Scheda «Tornei» del backgammon — la lista dei SOLI tornei di backgammon, con la riga
 * condivisa `LimuloTournamentCard` (reference `2026-09-23-backgammon-lobby.md`, punto 5).
 *
 * Il filtro e i cinque vuoti stanno su `useBackgammonTournaments`; qui si scrive solo cio' che
 * ognuno dice. ⛔ «Nessun torneo di backgammon» e' il caso 5 e si dice SOLO quando il server ha
 * parlato per intero (catalogo giochi compreso, e nessuna pagina in sospeso): quando non si
 * puo' chiedere (caso 4) si dice che la lista non e' stata richiesta, che e' un'altra cosa.
 *
 * ownScroll: la radice porta il proprio scorrevole, come gli altri pannelli dei giochi.
 */
export function QgammonTournamentsPanel() {
  const { t } = useTranslation('backgammon');
  const { t: tl } = useTranslation('limulo');
  const { state, tournaments, canLoadMore, loadingMore, loadMore, gameId } = useBackgammonTournaments();

  // ⚠️ Senza catalogo (o senza un backgammon nel catalogo) non si puo' chiedere niente, nemmeno le mie del gioco: il pannello
  // dice «non disponibile» e basta (caso 4, mai un «nessun torneo»).
  if (state.kind === 'cannot-ask') return <PanelNotice tone="unavailable" />;

  // Gli stati della lista pubblica si dicono DENTRO le tre tab pubbliche (I-346): «I miei» e' un'altra lettura.
  const avviso =
    state.kind === 'waiting' ? (
      <PanelWaiting slow={state.slow} />
    ) : state.kind === 'no-answer' ? (
      <PanelNotice tone="error" />
    ) : state.kind === 'failed' ? (
      <LimuloDegraded failure={limuloFailure(state.error)} context="list" />
    ) : null;
  const more = canLoadMore ? (
    <button
      type="button"
      disabled={loadingMore}
      onClick={loadMore}
      className="card-edge rounded-xl bg-bg-secondary px-4 py-3 text-sm font-semibold text-fg-muted disabled:opacity-40"
    >
      {loadingMore ? tl('list.loadingMore') : tl('list.loadMore')}
    </button>
  ) : null;

  return (
    <div
      data-testid="bg-tornei-panel"
      className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto overscroll-contain py-2"
    >
      {/* 🔑 LE QUATTRO TAB (I-346), lo stesso componente della Hub e della pagina. Con un'altra pagina in sospeso una tab vuota
          non afferma il vuoto: mostra solo il «Carica altri» (la regola di prima: la pagina dopo puo' avere proprio quello). */}
      <TorneiQuattroTab
        pubblicati={state.kind === 'ok' || state.kind === 'empty' ? tournaments : null}
        avviso={avviso}
        coda={more}
        vuotoDelGioco={t('tournaments.empty')}
        gameIdMiei={gameId}
      />
    </div>
  );
}
